import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { IPanelPageProps } from '~/lib/PanelApp';
import { getAppContext } from '~/lib/AppContext';
import { WithSearch } from '~/lib/helper/LocationHelper';
import { FreshdeskSsoPath, ZendeskSsoPath } from '~/lib/helper/RouteHelper';
import SupportSsoRedirect from './SupportSsoRedirect';
import PortalRedirect from './PortalRedirect';

export default class SupportPage extends React.Component<IPanelPageProps> {
    render() {
        return (
            <Routes>
                {/* Freshdesk's Simple-SSO Login URL reaches here via ClassicPanel's /mpanel/freshdesk redirect. */}
                <Route
                    path={FreshdeskSsoPath}
                    element={
                        <WithSearch>
                            {(search) => (
                                <SupportSsoRedirect
                                    serviceName="Freshdesk"
                                    returnTo={search.get('redirect_to')}
                                    /* A cold arrival from an alternative portal domain carries host_url (and no
                                       redirect_to); forwarding it signs the customer back into the domain they
                                       came from, and the endpoint rejects any host it does not recognise. */
                                    hostUrl={search.get('host_url')}
                                    getSsoUrl={(params) =>
                                        getAppContext().siteApiClient.getFreshdeskSso(params?.returnTo, params?.hostUrl)
                                    }
                                />
                            )}
                        </WithSearch>
                    }
                />
                {/* Zendesk's JWT SSO remote login URL points here, replacing ClassicPanel's /mpanel/zendesk. */}
                <Route
                    path={ZendeskSsoPath}
                    element={
                        <WithSearch>
                            {(search) => (
                                <SupportSsoRedirect
                                    serviceName="Zendesk"
                                    returnTo={search.get('return_to')}
                                    getSsoUrl={(params) =>
                                        getAppContext().siteApiClient.getZendeskSso(params?.returnTo)
                                    }
                                />
                            )}
                        </WithSearch>
                    }
                />
                <Route path="*" element={<PortalRedirect />} />
            </Routes>
        );
    }
}
